import React from "react";

import { ModuleRegistry, themeBalham } from "ag-grid-community";
import {
  AllEnterpriseModule,
  IntegratedChartsModule,
  LicenseManager,
} from "ag-grid-enterprise";
import { AgChartsCommunityModule } from "ag-charts-community";
import {
  AgGridReact as RealAgGridReact,
  AgGridReactProps,
} from "ag-grid-react";

import { GlobalColumnTypes } from "components/AgGrid/globalColumnTypes";
import { useIsMobile } from "hooks/useScreenSize";

import { EMPTY_OBJECT } from "lib";

ModuleRegistry.registerModules([
  AllEnterpriseModule,
  IntegratedChartsModule.with(AgChartsCommunityModule),
]);

const theme = themeBalham.withParams({
  fontFamily: "Roboto, system-ui, sans-serif",
});

LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-100504}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{AgriNous}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{AgriNous}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{AgriNous}_need_to_be_licensed___{AgriNous}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_November_2027}____[v3]_[01]_MTgyNTI4NjQwMDAwMA==0178a8349cd9c2d84b6208c1547b6b9a",
);

const AgGrid = ({
  defaultColDef,
  columnTypes = EMPTY_OBJECT as NonNullable<AgGridReactProps["columnTypes"]>,
  ...props
}: AgGridReactProps) => {
  const isMobile = useIsMobile();
  const allColumnTypes = React.useMemo(
    () => ({ ...GlobalColumnTypes, ...columnTypes }),
    [columnTypes],
  );

  return (
    <RealAgGridReact
      theme={theme}
      rowHeight={isMobile ? 40 : 26}
      defaultColDef={defaultColDef}
      columnTypes={allColumnTypes}
      animateRows={false}
      suppressColumnMoveAnimation={false}
      {...props}
    />
  );
};

export default AgGrid;
